import { render, staticRenderFns } from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiListComponent.vue?vue&type=template&id=12c7e94c"
import script from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiListComponent.vue?vue&type=script&lang=js"
export * from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports